import React from "react";
import PropTypes from "prop-types";
import MapaMinaDesktop from "./MapaMinaDesktop";

function MapaMina({ app, config }) {
  return <MapaMinaDesktop app={app} config={config} />;
}

MapaMina.defaultProps = {
  app: null,
  config: {},
};

MapaMina.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default MapaMina;
